<template>
<div id="geolocation"  class="content">
        <h4>{{ title }}</h4>
        <hr>
        <div class="row">
            <div class="col-sm-12">
                <router-link :to="`/${$i18n.locale}/geolocation/new`"><img src="../../assets/images/add_record.png" style="height: 22px; margin-bottom: 5px;"></router-link>
                <!--a href="" style="margin-left: 20px;"><u>IMPORT</u></a -->

                <a href="" @click.prevent="printPDF()" target="_blank"><img src="../../assets/images/print.png" alt="export to PDF" style="height: 22px; float: right; padding-left:8px"></a>
                <a href="" @click.prevent="getCSV"><img src="../../assets/images/download.png" style="height: 22px; float: right;"></a>

            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <v-card-title>
                
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
                </v-card-title>

                <v-data-table
                    :headers="headers"
                    :items="geolocations"
                    :pagination.sync="pagination"
                    :search="search"
                    class="elevation-1 fixed-header"
                >
                   <template slot="items" slot-scope="props">
                        <td class="justify-center layout px-0">
                            <v-icon
                                small
                                class="mr-2 pt-3"
                            @click="redirectTo('/' + $i18n.locale + '/geolocation/edit/' + props.item.id)"
                            >
                                edit
                            </v-icon>
                            <v-icon
                                small
                                class="pt-3"
                                @click="deleteGeolocation(props.item, props.item.location_name, props.item.id)"
                            >
                                delete
                            </v-icon>
                        </td>
                        <td class="text-xs-left">{{ props.item.location_code }}</td>
                        <td class="text-xs-left">{{ props.item.location_name }}</td>
                        <td class="text-xs-left">{{ props.item.location_longitude }}</td>
                        <td class="text-xs-left">{{ props.item.location_latitude }}</td>
                        <td class="text-xs-left">{{ props.item.radius_range }}</td>
                        <td class="text-xs-center">{{ props.item.enable | toggleYN }}</td>
                        <td></td>
                    </template>
                    <template slot="pageText" slot-scope="props">
                        Rows Per Page {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}
                    </template>
                </v-data-table>
            </div>
        </div>
</div>
</template>

<script>
import axios from 'axios'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'

import { enableToggle, yesNoToggle, checkNullVal } from '../common/toggle.js'

export default {
    data () {
        return {
            search: '',
            title: 'GEOFENCING',
            headers: [
                    { text: 'ACTION' , sortable: false, value: 'action' },
                    { text: 'LOCATION CODE' , value: 'location_code' },
                    { text: 'LOCATION NAME' , value: 'location_name' },
                    { text: 'LOCATION LONGITUDE', value: 'location_longitude' },
                    { text: 'LOCATION LATITUDE', value: 'location_latitude' },
                    { text: 'RADIUS RANGE (METRE)', value: 'radius_range' },
                    { text: 'ENABLE', value: 'enable' },
            ],
            geolocations: [],
            pagination: {'sortBy': 'activeFrom', 'sortBy': 'activeFrom', 'descending': true, 'rowPerPage': -1},
            
        }
    },
    
    methods: {
        loadUsers() {
            var vm = this

            axios.get(this.$store.getters.rootAPI + '/geolocation/list')
            .then(function (response) {
                vm.geolocations = response.data.rec
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error
                
            })
        },

        redirectTo(path) {
            this.$router.push(path)
        },

        deleteGeolocation(item, name, id) {
            var vm = this
            const index = vm.geolocations.indexOf(item)

            if(confirm('Are you sure you want to delete ' + name + '?')) {
                axios.delete(this.$store.getters.rootAPI + '/geolocation/' +  id)
                .then(function (response) {
                    if (response.data.status === "error") {
                        alert("Cannot delete geolocation " + name + " because it is in used!")
                    } else {
                        vm.geolocations.splice(index, 1)
                    }                    
                })
                .catch(function (error) {
                    alert('An error occured.')
                })
            }

            //confirm('Are you sure you want to delete this item?') && this.users.splice(index, 1)
        },

        objectToCSV(data) {
            const csvRows = []

            // get header
            const headers = Object.keys(data[0])
            csvRows.push(headers.join(','))

            // loop over the rows
            for (const row of data) {
                const values = headers.map(header => {
                    const escaped = ('' + row[header]).replace(/"/g, '\\"')
                    return `"${escaped}"`
                })
                csvRows.push(values.join(','))
            }
            return csvRows.join('\n')
        },

        download(data) {
            const blob = new Blob([data], { type: 'text/csv'})
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')

            a.setAttribute('hidden', '')
            a.setAttribute('href', url)
            a.setAttribute('download', this.title + '.csv')

            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        },

        async getCSV() {
            let item = this.geolocations
            let data = []
            for (var i = 0; i < item.length; i++) {

                data.push({
                    LOCATION_CODE: item[i].location_code,
                    LOCATION_NAME: item[i].location_name,
                    LOCATION_LONGITUTE: item[i].location_longitude,
                    LOCATION_LATITUTE: item[i].location_latitude,
                    RADIUS_RANGE_METRE: item[i].radius_range,
                    ENABLE: yesNoToggle(item[i].enable),        
                })
            }

            const csvData = this.objectToCSV(data)
            this.download(csvData)
        },

        printPDF() {
            const doc = new jsPDF({
                orientation: 'landscape'
            })
            let item = this.geolocations

            var head = [                
                { title: 'LOCATION CODE', dataKey: 'location_code' },
                { title: 'LOCATION NAME', dataKey: 'location_name' },
                { title: 'LOCATION LONGITUTE', dataKey: 'location_longitude' },
                { title: 'LOCATION LATITUTE', dataKey: 'location_latitude' },
                { title: 'RADIUS RANGE (METRE)', dataKey: 'radius_range' },
                { title: 'ENABLE', dataKey: 'enable' },
            ]

            let body = []

            for (var i = 0; i < item.length; i++) {
                body.push({                        
                        location_name: item[i].location_name,
                        location_code: item[i].location_code,
                        location_longitude: item[i].location_longitude,
                        location_latitude: item[i].location_latitude,
                        radius_range: item[i].radius_range,
                        enable: yesNoToggle(item[i].enable),
                    })
            }
            doc.text(this.title, 10, 10)
            doc.autoTable(head, body)
            doc.save(this.title + '.pdf')
        }
    },

    created() {
        this.loadUsers();
    }
}
</script>

<style lang="stylus">
@import '~vuetify-stylus-fixed-table-header';

.fixed-header {
  fixed-table-header(35vh)
}
</style>


// WEBPACK FOOTER //
// src/components/geolocation/Geolocation.vue